export default {
    getLastFeedback(state) {
        return state.lastFeedback;
    },
};
